import styled from '@xstyled/styled-components';
import React from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { LOGO } from '../itemIds';
import { select } from '~/lib/select';
import { useTrainingStore, TrainingState } from '~/training/state';
import { Logo as LogoUI } from '~/ui/logo/Logo';

interface Props {
  logo?: string;
}

const Wrapper = styled.div`
  width: 100%;
  img {
    margin: unset;
  }
  svg {
    margin: unset;
  }
`;

export type LogoDefinition = ItemDefinition<typeof LOGO, Props>;

const selector = (s: TrainingState) => select(s, 'logoUrl');

export class Logo extends Item<typeof LOGO, Props> {
  protected render({ logo }: RenderProps<Props>) {
    const { logoUrl } = useTrainingStore(selector);

    return (
      <Wrapper>
        <LogoUI src={logo || logoUrl} height={66} />
      </Wrapper>
    );
  }
}

registry[LOGO] = Logo;
